import { useContext } from "react";

import { teaserTrackingContext } from "./teaser-tracking.context";
import { TeaserTrackingContext } from "./teaser-tracking.types";

export const useTeaserTracking = (): TeaserTrackingContext => useContext(teaserTrackingContext);
